// ============================================================
// RIEE Articles — Data Types & Route Paths
// ============================================================

export const ROUTE_PATHS = {
  HOME: "/",
  ART_260: "/articulo/260",
  ART_261: "/articulo/261",
  ART_262: "/articulo/262",
  ART_263: "/articulo/263",
  ART_264: "/articulo/264",
  ART_265: "/articulo/265",
  ART_266: "/articulo/266",
} as const;

export type ArticleCategory = "ESTUDIOS" | "REFLEXIONES" | "RESEÑAS";

export interface Author {
  name: string;
  institution: string;
  country: string;
  email?: string;
  orcid?: string;
}

export interface AbstractContent {
  es: string;
  en: string;
}

export interface KeyFindings {
  label: string;
  value: string;
  unit?: string;
}

export interface Section {
  id: string;
  title: string;
  content: string[];
}

export interface Reference {
  id: number;
  text: string;
  doi?: string;
  url?: string;
}

export interface ArticleData {
  id: number;
  doi: string;
  category: ArticleCategory;
  title: string;
  titleEn?: string;
  authors: Author[];
  pagesStart: number;
  pagesEnd: number;
  receivedDate: string;
  acceptedDate: string;
  keywords: { es: string[]; en: string[] };
  abstract: AbstractContent;
  keyFindings: KeyFindings[];
  introduction: string[];
  methodology: Section[];
  results: Section[];
  conclusions: string[];
  references: Reference[];
  pdfUrl?: string;
  imageUrl?: string;
}
